import KeyboardArrowLeftRoundedIcon from "@mui/icons-material/KeyboardArrowLeftRounded";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { IconButton, Stack, Typography } from "@mui/material";
import { useDRMPYear } from "./logics";
import type { IYearRange } from "./types";

interface IDRMPYear {
  index: keyof IYearRange;
}

export const DRMPYear = ({ index }: IDRMPYear) => {
  const { year, onPrevious, onNext, canPrevious, canNext } = useDRMPYear(index);

  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <IconButton size="small" disabled={!canPrevious} onClick={onPrevious}>
        <KeyboardArrowLeftRoundedIcon />
      </IconButton>
      <Typography variant="body1SemiBold">{year}</Typography>
      <IconButton size="small" disabled={!canNext} onClick={onNext}>
        <KeyboardArrowRightRoundedIcon />
      </IconButton>
    </Stack>
  );
};
